<script setup lang="ts">
// Botão "RESGATAR PRÊMIO" do RewardCard.vue — mesma marcação usada idêntica
// no layout mobile e desktop do card; extraído pra não duplicar entre os dois.
type Props = {
  disabled?: boolean;
};

defineProps<Props>();

const emit = defineEmits<{ redeem: [] }>();
</script>

<template>
  <button
    class="flex h-[36px] shrink-0 items-center justify-center whitespace-nowrap rounded-[5px] border border-solid border-[#fc9984] bg-gradient-to-br from-[#ff704a] to-[#ff3400] px-[8px] py-[4px] text-[10px] font-extrabold text-white disabled:opacity-50"
    :disabled="disabled"
    type="button"
    @click="emit('redeem')"
  >
    RESGATAR PRÊMIO
  </button>
</template>
